import React, { FC, useContext, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ScreenContext } from 'react-components'
import { useTranslation } from '../../../../hooks/locale'
import { Dispatch } from '../../../../redux/types'
import { closeCancellationPolicyModal, getIsCancellationPolicyModalOpen } from '../../../../redux/filters'
import {
    CancellationPolicyReadMoreModal,
    CancellationPolicyHeader,
    CancellationPolicyIcon,
    CancellationPolicyText,
    CancellationPolicyCloseIcon,
    PolicyPoints,
    NewTagContainer,
    NewTagText,
    NewTagIcon,
} from '../../../app-components/filter-sort-section/styles'

interface Props {
    title: string
    policyPoints: string
}

const CancellationPolicyModal: FC<Props> = ({ title, policyPoints }) => {
    const dispatch = useDispatch<Dispatch>()
    const { t } = useTranslation()
    const { isMobile } = useContext(ScreenContext)
    const isOpen = useSelector(getIsCancellationPolicyModalOpen)

    const handleClose = useCallback(() => {
        dispatch(closeCancellationPolicyModal())
    }, [dispatch])

    return (
        <CancellationPolicyReadMoreModal isOpen={isOpen} onRequestClose={handleClose}>
            <CancellationPolicyHeader>
                <CancellationPolicyIcon />
                <CancellationPolicyText>
                    {title}
                    {!isMobile && (
                        <NewTagContainer>
                            <NewTagText>{t('new')}</NewTagText>
                            <NewTagIcon alt="new tag icon" />
                        </NewTagContainer>
                    )}
                </CancellationPolicyText>
                {!isMobile && <CancellationPolicyCloseIcon onClick={handleClose} />}
            </CancellationPolicyHeader>
            <PolicyPoints inputText={policyPoints} escapeHtml />
        </CancellationPolicyReadMoreModal>
    )
}

export default CancellationPolicyModal
